<button *ngIf="!isLinkButton"
        class="{{className}}"
        (click)="clickEvent()"
        matTooltip="{{tooltipText}}"
        type="button">
  <itb-icon [tooltipText]=""
            [className]="iconClassName"> </itb-icon>
</button>

<a *ngIf="isLinkButton"
   routerLink="{{link}}"><button class="{{className}}"
          (click)="clickEvent()"
          matTooltip="{{tooltipText}}"
          type="button">
    <itb-icon [tooltipText]=""
              [className]="iconClassName"> </itb-icon>
  </button></a>